import { ArrowDownOnSquareIcon } from "@/icons/outline";
import { addYears, format, subYears } from "date-fns";
import React, { useState } from "react";
import ReactDatePicker from "react-datepicker";
import { connect } from 'react-redux';
import { DateInputFormat } from "../../common/DateComponents.js";
import Spinner from "../../common/Spinner.js";
import { Actions as WORKFORCE_ACTIONS } from './store/workforceActions.js'
import Select from "react-select";

const WorkforceImport = ({
    importWorkforceEntries,
    importingTimesheets,
    importingLeave,
    isFor,
    employeeOptions,
    departmentOptions,
}) => {
    const [startDate, setStartDate] = useState(() => {
        const today = new Date();
        const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        return new Date(firstDayOfMonth.getTime() - (firstDayOfMonth.getTimezoneOffset() * 60000));
    });
    const [endDate, setEndDate] = useState(() => {
        const today = new Date();
        const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        return new Date(lastDayOfMonth.getTime() - (lastDayOfMonth.getTimezoneOffset() * 60000));
    });
	const [selectedEmployee, setSelectedEmployee] = useState();
	const [selectedDepartment, setSelectedDepartment] = useState();
    const [updateIfNotLast24Hours, setUpdateIfNotLast24Hours] = useState(false);

    if (!isFor) return null

    return (
        <div>
            <div className="row">
                <h5>Import {isFor} from Workforce</h5>
                <div className="col-xs-8 pl-0 flex" style={{flexWrap: "wrap"}}>

                    <div className="pl-0"
						style={{
                            maxWidth: "30%"
                        }}>
                        <label>From</label>
                        <ReactDatePicker
                            selected={startDate}
                            onChange={(date) => {
                                if (date) setStartDate(date)
                            }}
                            minDate={subYears(new Date(), 10)}
                            maxDate={addYears(new Date(), 10)}
                            dateFormat="dd/MM/yyyy"
                            customInput={<DateInputFormat />}
                        />
                        {/*<input id="date" type="text" className="form-control remove_error" name="date" />*/}
                        <div className="clearfix" />
                    </div>
                    <div
						style={{
                            marginLeft: 20,
                            maxWidth: "30%"
                        }}>
                        <label htmlFor=" ">To</label>
                        <ReactDatePicker
                            selected={endDate}
                            onChange={(date) => {
                                if (date) setEndDate(date)
                                if (startDate > date) setStartDate(date)
                            }}
                            minDate={subYears(new Date(), 10)}
                            maxDate={addYears(new Date(), 10)}
                            dateFormat="dd/MM/yyyy"
                            customInput={<DateInputFormat />}
                        />
                        <div className="clearfix" />
                    </div>
					<div className="col-xs-3">
						<label for=" ">Employee</label>
						<Select
							options={employeeOptions}
							value={selectedEmployee}
							onChange={setSelectedEmployee}
							isClearable
						/>
					</div>

					<div className="col-xs-3">
						<label for=" ">Department</label>
						<Select
							options={departmentOptions}
							value={selectedDepartment}
							onChange={setSelectedDepartment}
							isClearable
						/>
					</div>

                    <div className="clearfix" />


					<label className="css-input switch switch-sm switch-success">
						<input
							type="checkbox"
							className="update-company-settings"
							name="updateIfNotLast24Hours"
                            checked={updateIfNotLast24Hours}
                            onChange={() => setUpdateIfNotLast24Hours(!updateIfNotLast24Hours)}
						/>
						<span />
                        Force update of roundings and breaks in Workforce as per rules defined in Buddy.
					</label>

                </div>

                <div className="col-xs-4 pr-0" style={{ marginTop: 23 }}>
                    {(isFor === 'Timesheets' && importingTimesheets) || (isFor === 'Leave' && importingLeave) ?
                        <button className="btn btn-default pull-right">
                            <Spinner style={{ height: "1.5em", float: "left" }} className="animate-spin" />
                            <div style={{ float: "left", marginLeft: 5, marginRight: 5 }}>Importing</div>
                        </button>
                        :
                        <button
                            className='btn btn-default pull-right'
                            onClick={() => {
                                importWorkforceEntries(startDate, endDate, isFor, selectedEmployee?.value, selectedDepartment?.value, updateIfNotLast24Hours);
                            }}>
                            <ArrowDownOnSquareIcon style={{ height: "1.5em", float: "left" }} />
                            <div style={{ float: "left", marginLeft: 5, marginRight: 5 }}>Import from Workforce</div>
                        </button>
                    }
                </div>
            </div>

        </div>
    )
}


const mapStateToProps = (state, ownProps) => {

	const employeeOptions = state?.employees?.employeeListWithSalary?.map((employee) => ({
		value: employee.id,
		label: `${employee.employeeName} ${employee.employeeSurname}`,
		salary: employee.salaries[employee.salaries.length - 1],
	}));

	const departmentOptions = state?.company?.settings?.departments?.map((department) => ({
		value: department.id,
        label: department.name,
	}));

    return {
        importingTimesheets: state.integration?.timeAttendance?.tanda?.importingTimesheets,
        importingLeave: state.integration?.timeAttendance?.tanda?.importingLeave,
        employeeOptions,
        departmentOptions,
    }
}

const mapDispatchToProps = dispatch => ({
    importWorkforceEntries: (from, to, type, agreementId, department, updateIfNotLast24Hours) => dispatch(WORKFORCE_ACTIONS.importWorkforceEntries({
        from,
        to,
        type,
        agreementId,
        department,
        updateIfNotLast24Hours
    })),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WorkforceImport) 